import { createSelector } from "reselect";
import { HERO_LEVELS } from "../../Classes/utils/constants";

export const getName = hero => hero.name;
export const getClassType = hero => hero.classType;
export const getLevel = hero => hero.level;
export const getXp = hero => hero.xp;
export const getGold = hero => hero.gold;
export const getGender = hero => hero.gender;
export const getMaxHealth = hero => hero.stats.maxHealth;
export const getHealth = hero => hero.stats.health;
export const getMana = hero => hero.stats.mana;
export const getMaxMana = hero => hero.stats.maxMana;
export const getStrength = hero => hero.stats.strength;
export const getIntelligence = hero => hero.stats.intelligence;
export const getDexterity = hero => hero.stats.dexterity;
export const getVitality = hero => hero.stats.vitality;


// export const getLevel = hero => HERO_LEVELS.filter(level => getXp(hero) >= level.xp).length;
// export const getLevel = createSelector(
//     getXp,
//     xp => HERO_LEVELS.filter(level => xp >= level.xp).length
// )
// export const getMaxHealth = hero => HERO_LEVELS[getLevel(hero)].maxHealth;
// export const getMaxHealth = createSelector(
//     getLevel,
//     level => HERO_LEVELS[level-1].maxHealth
// )
// export const isHealthLow = hero => getHealth(hero) < getMaxHealth(hero) * 0.15;
export const isHealthLow = createSelector(
    [getHealth, getMaxHealth],
    (health, maxHealth) => health < maxHealth * 0.15
)

export const isHealthDown = createSelector(
    [getHealth],
    (health) => health === 0
)

export const getSkin = hero => {
    if (hero.gender == 'male') {
        return hero.skinMale
    } else {
        return hero.skinFemale
    }
}

//SELECTOR POUR LA MANA

export const isManaLow = createSelector(
    [getMana, getMaxMana],
    (mana, maxMana) => mana < maxMana * 0.15
)

export const checkWealthness = createSelector(
    getGold,
    gold => {
        if (gold > 1000) {
            return 'excellent'
        } else if ( gold > 500) {
            return 'good'
        } else if (gold > 100) {
            return 'medium'
        } else {
            return 'bad'
        }
    }
)